export default __webpack_public_path__ + "static/media/arrow_downward.252cdc5b.svg";